import React, { useEffect, useState } from "react";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  Snackbar,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  ButtonGroup,
  OutlinedInput,
  CircularProgress,
  Breadcrumbs,
  HomeIcon,
  FormControl,
  Select,
  InputLabel,
  MuiAlert,
  MenuItem,
  NavLink,
  makeStyles,
  withStyles,
  useTheme,
  commonService,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  AddBoxIcon,
  SearchIcon,
  AddIcon,
  SpeedIcon,
} from "../../../common";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  root1: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
  root: {
    marginTop: "5rem",
  },
  btnStyle: {
    backgroundColor: "#1DBF73",
    color: "white",
    fontWeight: "400",
    "&:hover": {
      backgroundColor: "#11a962",
    },
  },
  listIcon: { width: 20, paddingRight: theme.spacing(0.5) },

  table: {
    marginTop: "1.5rem",
  },
  rowPadding: {
    padding: "0.125rem 0.25rem 0 0",
  },
  formControl: {
    margin: theme.spacing(1),
    // minWidth: 120,
  },
  selectEmpty: {
    // marginTop: theme.spacing(2),
  },
  link: {
    display: "flex",
    textDecoration: "none",
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
  active: {
    border: "1px solid #1DBF73",
    textTransform: "Capitalize",
    color: "#1DBF73",
    backgroundColor: "#1DBF7333",
  },
  disabled: {
    border: "1px solid #1DBF73",
    textTransform: "Capitalize",
    color: "#BEBDBD",
  },
  borderRemove: {
    borderBottom: "none",
    paddingLeft: "0",
  },
  btnIcon: {
    paddingRight: "5px",
    fontSize: "20px",
  },
}));

export default function LevelList() {
  const classes = useStyles();
  const [levels, setLevels] = useState([]);
  const [level_id, setLevel_id] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [userTypeList, setUserTypeList] = useState([]);
  const [transactionTypeList, setTransactionTypeList] = useState([]);
  const [limitTypeList, setLimitTypeList] = useState([]);

  const [transactionType, setTransactionType] = useState("");
  const [level, setLevel] = useState("");
  const [userType, setUserType] = useState("");
  const [limit, setLimit] = useState("");
  const [noOfTransaction, setNoOfTransaction] = useState("");
  const [transactionAmount, setTransactionAmount] = useState([]);
  const [levelTypeList, setLevelTypeList] = useState([]);
  const [limitList, setLimitList] = useState([]);

  const [count, setCount] = React.useState(20);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(16);
  const [errorMsgBody, setErrorMsgBody] = useState("");
  const [successMsgBody, setSuccessMsgBody] = useState("");
  const [error, setError] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [dataTableIsLoading, setDataTableIsLoading] = React.useState(true);
  const [status, setStatus] = useState("");

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleErrorClose = (event) => {
    setError(false);
  };

  const handleDelete = async () => {
    setDataTableIsLoading(true);

    const info = {
      id: level_id,
    };

    const res = await commonService.deleteLevel(info);
    console.log("response");
    res?.code === 200 && setOpen(true);
    setSuccessMsgBody("Successfully Deleted.");

    res?.code !== 200 && setError(true);
    setRefresh(!refresh);
    setErrorMsgBody(res.messages[0]);
    setConfirmOpen(false);
    setDataTableIsLoading(false);
  };

  const handleClickClose = () => {
    setConfirmOpen(false);
  };

  const getLevel = async () => {
    setDataTableIsLoading(true);
    const res = await commonService.getAllLevel();
    console.log("response", res);
    if (res.code === 200 && res.data.levels.length === 0) {
      setError(true);
      setErrorMsgBody("No Data Found");
      setDataTableIsLoading(false);
    } else if (res.code === 200) {
      setLevels(res && res.data && res.data.levels);
      setDataTableIsLoading(false);
    } else {
      setError(true);
      setErrorMsgBody(res.messages[0]);
      setDataTableIsLoading(false);
    }
  };

  const StyledTableCell = withStyles((theme) => ({
    root: {
      //   padding: '0.125rem 0.25rem',
    },
    head: {
      backgroundColor: theme.palette.common.white,
      fontSize: "1.125rem",
      letterSpacing: "0.014375rem",
      fontWeight: "500",
      color: "#2B335E",
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  useEffect(() => {
    getLevel();

    // handleSearch();
  }, [refresh]);

  return (
    <Container maxWidth="xl" className={classes.root}>
      <Snackbar
        open={open}
        autoHideDuration={1500}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity="success">
          {successMsgBody}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={error}
        autoHideDuration={1500}
        onClose={handleErrorClose}
      >
        <Alert onClose={handleErrorClose} severity="error">
          {errorMsgBody}
        </Alert>
      </Snackbar>
      <Breadcrumbs style={{ marginTop: "10px" }} aria-label="breadcrumb">
        <NavLink
          to="/dashboard"
          style={{ color: "#2B335E99" }}
          className={classes.link}
        >
          <HomeIcon className={classes.icon} />
          Home
        </NavLink>
        <NavLink
          to="/level"
          style={{ color: "#2B335E99" }}
          className={classes.link}
        >
          <SpeedIcon className={classes.icon} />
          Level
        </NavLink>
        <Typography style={{ color: "#2B335E" }} className={classes.link}>
          <AddBoxIcon className={classes.listIcon} /> List
        </Typography>
      </Breadcrumbs>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          style={{
            textAlign: "left",
            margin: "15px 0",
            color: "#2B335E",
            fontSize: "25px",
          }}
        >
          Level List
        </Typography>

        <NavLink
          to="/level-create"
          variant="contained"
          style={{ height: "30px", textDecoration: "none" }}
        >
          <Button
            className="btn btn-primary btn-block"
            size="medium"
            variant="contained"
          >
            <AddIcon style={{ paddingRight: "5px" }} /> Create Level
          </Button>
        </NavLink>
      </div>

      {dataTableIsLoading === true ? (
        <Box mt={15}>
          {" "}
          <CircularProgress
            size={80}
            className={classes.progress}
            thickness={2}
          />
        </Box>
      ) : (
        <TableContainer component={Paper} className={classes.table}>
          {levels && levels.length > 0 && (
            <>
              <Table
                aria-labelledby="tableTitle"
                size="small"
                padding="default"
                aria-label="simple table"
                //     style={{ width: "max-content" }}
              >
                <TableHead>
                  <TableRow
                    className={classes.tableHeader}
                    style={{ height: "70px" }}
                  >
                    <StyledTableCell>ID</StyledTableCell>
                    <StyledTableCell>Name</StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                    <StyledTableCell>Create At</StyledTableCell>
                    {/* <StyledTableCell style={{ width: "200px" }}>
                      Action
                    </StyledTableCell> */}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {levels &&
                    levels.length > 0 &&
                    levels.map((item) => (
                      <>
                        <StyledTableRow
                          key={item.id}
                          style={{ cursor: "pointer" }}
                        >
                          <StyledTableCell>{item.id}</StyledTableCell>
                          <StyledTableCell>{item.name}</StyledTableCell>
                          <StyledTableCell>
                            {item.status === 1 ? <CheckIcon /> : <ClearIcon />}
                          </StyledTableCell>
                          <StyledTableCell>{item.created_at}</StyledTableCell>
                          <StyledTableCell>
                            {/* <IconButton
                              color="secondary"
                              onClick={(e) => {
                                setLevel_id(item.id);
                                setConfirmOpen(true);
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                            <a
                              href={`/level-create?update_id=${item.id}&name=${item.name}`}
                            >
                              <IconButton color="primary">
                                <EditIcon />
                              </IconButton>
                            </a> */}
                          </StyledTableCell>
                        </StyledTableRow>
                      </>
                    ))}
                </TableBody>
              </Table>
            </>
          )}
        </TableContainer>
      )}

      <Dialog
        open={confirmOpen}
        onClose={handleClickClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Are you Sure"}</DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions>
          <Button onClick={handleClickClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="primary" autoFocus>
            Delete Now
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
